import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Translations } from '@core/models/translations.model';
import { AuthFacade } from '../../auth.facade';
import { OtpComponent } from '../otp/otp.component';
import { AuthType } from '@core/enums/auth.enum';
import { SnackService } from '@shared/services/snack.service';

@Component({
	selector: 'app-update-mobile',
	templateUrl: './update-mobile.component.html',
	styleUrls: ['./update-mobile.component.scss'],
})
export class UpdateMobileComponent implements OnInit {
	constructor(private readonly authFacade: AuthFacade, private readonly snackService: SnackService) {}

	@Input() phone: string;
	@Input() phonePrefix: string;
	@Input() phoneWithCountryCode: string;
	@Input() translations: Translations;

	@Output() changed = new EventEmitter();

	async onContinue(): Promise<void> {
		/**
		 * Firebase phone authentication first then fallback error to Twilio authentication.
		 */
		try {
			//FIREBASE CODE
			// await this.authFacade.signInWithPhoneNumber(this.phoneWithCountryCode);

			//TWILIO CODE
			await this.authFacade.signInWithPhoneNumberTwilio({
				phone: this.phone,
				phonePrefix: this.phonePrefix,
			});
			this.gotoOtp(this.phone, this.phonePrefix, this.phoneWithCountryCode);
		} catch (error) {
			this.snackService.open(this.translations['n270'], 5000, null, 'error'); // remove this after TWILIO is back

			// TWILIO CODE
			// this.authFacade
			// 	.signInWithPhoneNumberTwilio({
			// 		phone: this.phone,
			// 		phonePrefix: this.phonePrefix,
			// 	})
			// 	.then(() => this.gotoOtp(this.phone, this.phonePrefix, this.phoneWithCountryCode))
			// 	.catch(() => this.snackService.open(this.translations['n174'], 5000, null, 'error'));
			// this.snackService.open(this.translations['n174'], 5000, null, 'error');
		}
	}

	/**
	 * Go to OTP screen
	 */
	private gotoOtp(phone: string, phonePrefix: string, phoneWithCountryCode: string): void {
		this.changed.emit({
			component: OtpComponent,
			phone,
			phonePrefix,
			phoneWithCountryCode,
			authType: AuthType.VERIFY_OLD_MOBILE,
		});
	}

	ngOnInit(): void {}
}
